import {
  ADD_TEXT_TO_DRAFT_SUCCESS,
  ADD_TEXT_TO_DRAFT_ERROR,
  ADD_IMAGE_TO_DRAFT_SUCCESS,
  ADD_IMAGE_TO_DRAFT_ERROR,
  REMOVE_IMAGE_FROM_DRAFT_SUCCESS,
  REMOVE_IMAGE_FROM_DRAFT_ERROR,
  ADD_FRIEND_TO_DRAFT_SUCCESS,
  ADD_FRIEND_TO_DRAFT_ERROR,
  ADD_DATE_TO_DRAFT_SUCCESS,
  ADD_DATE_TO_DRAFT_ERROR,
  ADD_LOCATION_TO_DRAFT_SUCCESS,
  ADD_LOCATION_TO_DRAFT_ERROR,
  DRAFT_CREATE_SUCCESS,
  DRAFT_CREATE_ERROR,
} from '../actions/types';

const INITIAL_STATE = {
  text: undefined,
  images: [],
  friend: '',
  currentScreen: '',
};

const draftReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_TEXT_TO_DRAFT_SUCCESS:
      return { ...state, text: action.payload };
    case ADD_TEXT_TO_DRAFT_ERROR:
      return state;
    case ADD_IMAGE_TO_DRAFT_SUCCESS:
      return { ...state, images: state.images.concat(action.payload) };
    case ADD_IMAGE_TO_DRAFT_ERROR:
      return state;
    case REMOVE_IMAGE_FROM_DRAFT_SUCCESS:
      return { ...state, images: state.images.filter((item) => item !== action.payload) };
    case REMOVE_IMAGE_FROM_DRAFT_ERROR:
      return state;
    case ADD_FRIEND_TO_DRAFT_SUCCESS:
      return { ...state, friend: action.payload };
    case ADD_FRIEND_TO_DRAFT_ERROR:
      return state;
    case ADD_DATE_TO_DRAFT_SUCCESS:
      return { ...state, date: action.payload };
    case ADD_DATE_TO_DRAFT_ERROR:
      return state;
    case ADD_LOCATION_TO_DRAFT_SUCCESS:
      return { ...state, location: action.payload };
    case ADD_LOCATION_TO_DRAFT_ERROR:
      return state;
    case DRAFT_CREATE_SUCCESS:
      return INITIAL_STATE;
    case DRAFT_CREATE_ERROR:
      return state;
    default:
      return state;
  }
};

export default draftReducer;
